import * as React from "react";
import Avatar from "@mui/material/Avatar";
import { Stack, Typography, AvatarProps } from "@mui/material";
import styles from "./MuiAvatar.module.css";
import strings from "../../../strings/Strings";

interface IImageAvatars {
  imageUrl: string;
  id: number;
}
interface CustomAvatarProps extends AvatarProps {
  numberOfAvatars: number;
  imageAvatars: IImageAvatars[];
  variant: "square" | "circular" | "rounded";
  sx: object;
  ClassName?: any;
  isOtherTextNotThere?: boolean;
  isShowOthersCount?: boolean;
}
const CustomAvatar: React.FC<CustomAvatarProps> = ({
  isShowOthersCount = true, // default value set to true
  ...props }) => {
  return (
    <Stack spacing={0.1} alignItems={"center"}>
      {props?.imageAvatars?.map((item: any, index: any) => {
        return (
          <>
            {props.imageAvatars.length === 0 && (
              <Typography
                style={{ color: "white" }}
                color={"white"}
                zIndex={10000}
              >
                {`Suggested for you`}
              </Typography>
            )}
            {index + 1 <= props.numberOfAvatars ? (
              <Avatar
                src={item.profilePic || item.imageUrl}
                key={index}
                alt=""
                className={
                  props?.imageAvatars?.length > 1
                    ? styles["avatar"]
                    : styles["single-avatar"]
                }
                variant={props.variant}
                sx={props.sx}
              />
            ) : null}
            {index + 1 === props.imageAvatars.length &&
              props.numberOfAvatars > props?.imageAvatars?.length ? (
              <>
                {isShowOthersCount ?
                  <Typography
                    className={
                      props?.className
                        ? props?.className
                        : styles["avatar-typography"]
                    }
                  >{`+${props.numberOfAvatars - props?.imageAvatars?.length} ${props.isOtherTextNotThere ? "" : strings.others
                    }`}</Typography>
                  :
                  <Typography
                    style={{ color: 'var(--secondary-lite-grey-color)' , marginLeft: '1rem'}}
                  >Mutuals</Typography>
                }
              </>
            ) : null}
          </>
        );
      })}
    </Stack>
  );
};

export default CustomAvatar;
